import { handleFileDownload } from 'app/api/accounting'
import R from 'app/assets/R'
import { NOTIFICATION_TYPE } from 'app/common/constants'
import {
  FunctionPermissionEnum,
  ModulePermissionEnum,
} from 'app/common/permission-module'
import { useVerifyPermissionAndRedirect } from 'app/common/use-verify-permission-redirect'
import { IResponseFilter } from 'app/components/tables/BaseTableReport/FilterReport/type'
import { downloadNotificationController } from 'app/controllers/download-notification-controller'
import { useAppDispatch, useAppSelector } from 'app/redux/hooks'
import { changeMessage } from 'app/redux/slices/profileSlice'
import { isEqual } from 'lodash'
import { Pagination } from 'parkway-web-common'
import { SetStateAction, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTablePaymentTypeHook } from './PaymentType/hook'

export const useTableHook = () => {
  const { t } = useTranslation()

  const [filterResponse, setFilterResponse] = useState<IResponseFilter>()
  const [exportFile, setExportFile] = useState<string[]>([])

  const { isHavePermissionFunctionAndGoBack } = useVerifyPermissionAndRedirect()
  const profile = useAppSelector(state => state.profileSlice)
  const notificationMessage = profile?.message
  const {columns, metadata, onClickExport, onClickSync, setPagination, tableData} = useTablePaymentTypeHook({ params: filterResponse })
  const dispatch = useAppDispatch()

  useEffect(() => {
    isHavePermissionFunctionAndGoBack(
      ModulePermissionEnum.ACCOUNTING,
      FunctionPermissionEnum.READ_DAILY_INVOICE,
      R.strings.role,
    )
    setExportFile([])
  }, [])

  useEffect(() => {
    if (notificationMessage?.type !== NOTIFICATION_TYPE.EXPORT_DAILY_INVOICE)
      return

    const payload = JSON.parse(notificationMessage?.payload || '')
    const successData = payload?.successData || []
    const errorData = payload?.errorData || []

    if (errorData?.length) {
      downloadNotificationController.downloadErrored({
        duration: 2,
        key: NOTIFICATION_TYPE.EXPORT_DAILY_INVOICE,
        message: t(R.strings.daily_invoice),
        description: t(R.strings.download_errored),
        cancel: t(R.strings.cancel),
      })
    } else if (!isEqual(exportFile, successData)) {
      setExportFile(successData)
      downloadNotificationController.close(
        NOTIFICATION_TYPE.EXPORT_DAILY_INVOICE,
      )
    }
  }, [notificationMessage?.currentTime, notificationMessage?.type])

  const downloadFileForExport = () => {
    if (!exportFile?.length) return

    exportFile.forEach(file =>
      handleFileDownload(
        file,
        t,
        t(R.strings.daily_invoice),
        NOTIFICATION_TYPE.EXPORT_DAILY_INVOICE,
      ),
    )

    setExportFile([])
    dispatch(changeMessage({}))
  }

  useEffect(() => {
    downloadFileForExport()

    return downloadFileForExport
  }, [exportFile])

  const handleChangeFilter = (
    filter: SetStateAction<IResponseFilter | undefined>,
  ) => {
    setFilterResponse(filter)
  }

  const handleTableChange = (pagination: Pagination) => {
    setPagination(pagination)
  }

  return {
    columns,
    tableData,
    metadata,
    handleTableChange,
    handleChangeFilter,
    filterResponse,
    onClickExport,
    onClickSync,
  }
}
